@if (loading) {
  <div class="spinner-container">
    <mat-spinner [color]="color" [diameter]="diameter"></mat-spinner>
  </div>
}

@if (!loading) {
  <ng-content></ng-content>
}
